export const REQUEST_TESTIMONIAL_FETCH_AD = "REQUEST_TESTIMONIAL_FETCH_AD";
export const FETCH_TESTIMONIAL_AD_SUCCESS = "FETCH_TESTIMONIAL_AD_SUCCESS";
export const FETCH_TESTIMONIAL_AD_FAILURE = "FETCH_TESTIMONIAL_AD_FAILURE";

export const CLEAR_FETCH_TESTIMONIAL_AD_STATES =
  "CLEAR_FETCH_TESTIMONIAL_AD_STATES";
